export class OpenPageActivity {
  constructor({router}, {PageId, PageParams}) {
    this.pageId  = PageId
    this.pageParams  = PageParams
    this.$router = router
  }

  run() {
    this.$router.push({ name: this.pageId, query: this.pageParams })
    
  }
}